// @ts-nocheck
import Button from '@rio-cloud/rio-uikit/Button';
import Spinner from '@rio-cloud/rio-uikit/Spinner';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { exportPdfAction, pdfDownloadIsPending } from '@/actions/pdcActions';
import { getPDCDownloads } from '@/selectors';

const PDFDownloadButtonComponentWithoutInjection = ({
    formatMessage,
    locale,
    pdfUrl,
    exportPdf,
    setDownloadPending,
    pdcDownloads,
    analyticsStore,
}) => {
    const urlWithLocale = `${pdfUrl}?locale=${locale}`;
    const showLoadingSpinner = pdcDownloads?.[urlWithLocale];

    // using this ensures that line height does not change while loading the PDF
    // and also that line height is not smaller if pdfUrl does not exist
    const hiddenButtonPlaceholder = (
        <button type='button' className='visibility-hidden btn btn-link btn-link-inline'>
            <span className='uikit-icon icon-pdf-file' />
        </button>
    );

    if (!pdfUrl) {
        return hiddenButtonPlaceholder;
    }

    if (showLoadingSpinner) {
        return (
            <div className='display-flex justify-content-center align-items-center'>
                {hiddenButtonPlaceholder}
                <Spinner />
                {hiddenButtonPlaceholder}
            </div>
        );
    }

    return (
        <Button
            bsStyle={Button.PRIMARY}
            variant={Button.VARIANT_LINK_INLINE}
            iconName='pdf-file'
            onClick={event => {
                event?.stopPropagation(); // avoid triggering other onClick handlers besides this one
                setDownloadPending(urlWithLocale, analyticsStore);
                exportPdf(`${pdfUrl}?locale=${locale}`);
            }}
        >
            {formatMessage({ id: 'intl-msg:download' })}
        </Button>
    );
};

PDFDownloadButtonComponentWithoutInjection.propTypes = {
    formatMessage: PropTypes.func.isRequired,
    locale: PropTypes.string.isRequired,
    exportPdf: PropTypes.func.isRequired,
    pdfUrl: PropTypes.string.isRequired,
    setDownloadPending: PropTypes.func.isRequired,
    pdcDownloads: PropTypes.object,
    analyticsStore: PropTypes.any,
};

const PDFDownloadButtonComponent = props => {
    const dispatch = useDispatch();
    const pdcDownloads = useSelector(getPDCDownloads);

    return (
        <PDFDownloadButtonComponentWithoutInjection
            {...props}
            pdcDownloads={pdcDownloads}
            exportPdf={url => dispatch(exportPdfAction(url))}
            setDownloadPending={(pdfUrl, analyticsStore) => dispatch(pdfDownloadIsPending(pdfUrl, analyticsStore))}
        />
    );
};

export { PDFDownloadButtonComponentWithoutInjection };
export default injectIntl(PDFDownloadButtonComponent);
